import { z } from 'zod'

import { successResponseSchema } from '@/api/resources/shared/success'
import { playerRankSchema } from '@/api/resources/arcade/rank/get/schema'
import { seasonSchema } from '@/api/resources/shared/arcade'

const MINI_LEADERBOARD_SIZE = 3

const miniLeaderboardGetInputSchema = z.object({
  account: z.string().optional()
})

export const miniPlayerRankSchema = playerRankSchema.omit({
  id: true,
  season_id: true
})

export const miniLeaderboardSchema = z.object({
  season: seasonSchema,
  player_rank: z.number(),
  total_players: z.number(),
  points_to_threshold: z.number(),
  leaderboard: z
    .array(miniPlayerRankSchema)
    .min(MINI_LEADERBOARD_SIZE)
    .max(MINI_LEADERBOARD_SIZE)
})

export const miniLeaderboardGetResponseSchema = successResponseSchema.extend({
  data: miniLeaderboardSchema
})

export type MiniPlayerRank = z.infer<typeof miniPlayerRankSchema>
export type MiniLeaderboard = z.infer<typeof miniLeaderboardSchema>

export type MiniLeaderboardGetInput = z.infer<
  typeof miniLeaderboardGetInputSchema
>
export type MiniLeaderboardGetResponse = z.infer<
  typeof miniLeaderboardGetResponseSchema
>
